import { render, staticRenderFns } from "./SafetyObservations.vue?vue&type=template&id=359c5674&"
import script from "./SafetyObservations.vue?vue&type=script&lang=js&"
export * from "./SafetyObservations.vue?vue&type=script&lang=js&"
import style0 from "./SafetyObservations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports